import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { AuthModule } from '@numbox/modules';

import { CircularProgress } from '@library/animations/CircularProgress';

import { getQueryParam } from '~/util/urls';

import { AskToSetPassword } from './AskToSetPassword';
import { ROUTES } from './constants';

export const MagicLink = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = getQueryParam('token');
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (token) {
      dispatch(
        AuthModule.exchangeToken.request(
          { token, token_type: 'MAGIC_LINK' },
          {
            onSuccess: () => setLoggedIn(true),
            onFailure: () => history.push(ROUTES.LOGIN),
          },
        ),
      );
    } else {
      history.push(ROUTES.LOGIN);
    }
  }, [history, token, dispatch]);
  if (loggedIn) {
    return <AskToSetPassword />;
  }
  return <CircularProgress />;
};
